import { Pagination } from 'src/app/shared/models';
import { SharedState } from './state';
import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';

export const selectSharedState: MemoizedSelector<object, SharedState> = createFeatureSelector<SharedState>('shared');

const getIsLoading = (state: SharedState): boolean => state.isLoading;
const getPaginationData = (state: SharedState): Pagination => state.pagination;

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectSharedState, getIsLoading);

export const selectPaginationData: MemoizedSelector<object, Pagination> = createSelector(
  selectSharedState,
  getPaginationData,
);
